import { DateTime } from 'luxon';
import { Card } from 'nhsuk-react-components';
import { Link } from 'react-router-dom';
import { Iteration } from 'schemas/Iteration.schema.ts';
import { IterationDetails } from 'schemas/CampaignConfig.schema.ts';
import { getIsCurrentSummaryReport } from 'utils/summaryReports.ts';
import {
  SUMMARY_REPORT_REVIEW_STATUSES,
  SummaryReport,
} from 'schemas/SummaryReport.schema.ts';
import { ITERATION_STATUS } from 'schemas/CampaignApiDetails.schema.ts';
import SummaryReportHeaderStatus from 'components/SummaryReportPageHeader/summaryReportHeaderStatus.tsx';

interface ISummaryReportPageHeaderProps {
  iteration: Iteration;
  iterationDetails: IterationDetails;
  report: SummaryReport;
  title: string;
  summaryUrl: string;
  isLatestSummaryReport: boolean;
}

function SummaryReportPageHeader({
  iteration,
  iterationDetails: { status: iterationStatus },
  report,
  title,
  summaryUrl,
  isLatestSummaryReport,
}: ISummaryReportPageHeaderProps) {
  const { Name } = iteration;
  const { status } = report.summary_report_review ?? {};
  const isCurrent = getIsCurrentSummaryReport(report, iteration);

  return (
    <Card>
      <>
        <h1
          role="main"
          id="maincontent"
          className="nhsuk-heading-l nhsuk-u-margin-top-0 nhsuk-u-margin-bottom-0"
        >
          {title}
        </h1>
        <h2 style={{ fontSize: '16px', fontWeight: 300 }}>
          {report.dry_run ? 'Dry run' : 'Live run'}
        </h2>
        <p className="nhsuk-u-margin-bottom-0">
          Iteration :
          {' '}
          <Link to={summaryUrl}>{Name}</Link>
        </p>

        <p className="nhsuk-u-margin-bottom-1">
          Status:
          {' '}
          <SummaryReportHeaderStatus
            isCurrent={isCurrent}
            iterationStatus={iterationStatus as ITERATION_STATUS}
            summaryReportStatus={status as SUMMARY_REPORT_REVIEW_STATUSES}
            isLatestSummaryReport={isLatestSummaryReport}
          />
        </p>
        {report.run_time ? (
          <p className="nhsuk-u-margin-bottom-1">
            Run date:
            {' '}
            {DateTime.fromSQL(report.run_time)
              .setLocale('en-GB')
              .toFormat('dd LLLL yyyy')}
          </p>
        ) : null}

        {report.run_time
        && iterationStatus !== ITERATION_STATUS.SENT_TO_NHS_NOTIFY ? (
          <p className="nhsuk-u-margin-bottom-1">
            Expiry time and date:
            {' '}
            {DateTime.fromSQL(report.run_time)
              .setLocale('en-GB')
              .plus({ days: 1 })
              .set({
                hour: 17,
                minute: 0,
                second: 0,
                millisecond: 0,
              })
              .toFormat('HH:mm, dd LLLL yyyy')}
          </p>
          ) : null}
      </>
    </Card>
  );
}

export default SummaryReportPageHeader;
